import React, { useEffect, useState } from "react";
import ExhibitorLayout from "../ExhibitorLayout";
import BasePackPdf from '../../../assets/boj-pdf/BOJ_Fineness_Form.docx';
import axios from "axios";
import { Button, Spinner, Card, Alert } from "react-bootstrap";
import { message } from "antd";

const UndertakingForm = () => {
  const [file, setFile] = useState(null);
  const [uploaded, setUploaded] = useState(false);
  const [fileUrl, setFileUrl] = useState(null);
  const [loading, setLoading] = useState(true);
  const [uploading, setUploading] = useState(false);

  // 🔹 API + STATIC base separation (IMPORTANT FIX)
  const API_BASE = process.env.REACT_APP_API_END_POINT;
  const STATIC_BASE = API_BASE.split("/api")[0]; // removes /api

  // ============================
  // LOAD CURRENT STATUS
  // ============================
  useEffect(() => {
    axios
      .get(`${API_BASE}/undertaking/status`, {
        headers: {
          token: localStorage.getItem("jff_token"),
          barcode: localStorage.getItem("user_id")
        }
      })
      .then(res => {
        if (res.data.status === "UPLOADED") {
          setUploaded(true);
          setFileUrl(res.data.fileUrl);
        }
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  // ✅ FINAL FILE URL (correct static serving)
  const fullFileUrl = fileUrl ? `${STATIC_BASE}${fileUrl}` : null;

  // ============================
  // UPLOAD FILE
  // ============================
  const uploadFile = () => {
    if (!file) return message.error("Please select a file");

    const allowed = [
      "application/pdf",
      "image/png",
      "image/jpg",
      "image/jpeg"
    ];

    if (!allowed.includes(file.type))
      return message.error("Only PDF, PNG, JPG, JPEG allowed");

    if (file.size > 2 * 1024 * 1024)
      return message.error("Max 2MB allowed");

    setUploading(true);

    const formData = new FormData();
    formData.append("file", file);

    axios
      .post(`${API_BASE}/undertaking/upload`, formData, {
        headers: {
          token: localStorage.getItem("jff_token"),
          barcode: localStorage.getItem("user_id")
        }
      })
      .then(res => {
        setUploaded(true);
        setFileUrl(res.data.fileUrl);
        message.success("Undertaking uploaded successfully");
      })
      .catch(() => message.error("Upload failed"))
      .finally(() => setUploading(false));
  };

  // ============================
  // LOADING STATE
  // ============================
  if (loading)
    return (
      <ExhibitorLayout title="Undertaking Form">
        <div className="d-flex justify-content-center p-5">
          <Spinner animation="border" />
        </div>
      </ExhibitorLayout>
    );

  // ============================
  // UI
  // ============================
  return (
    <ExhibitorLayout title="Undertaking Form">

      <div className="mb-5">
        <div className="form-body mt-3">

          <div className="text-center mb-4">
            <h3 className="text-decoration-underline">
              Undertaking Form
            </h3>
          </div>

          <div className="container" style={{ maxWidth: "850px" }}>
            <Card className="shadow-sm p-4">

              <div className="d-flex justify-content-end mt-3">
                <a href={BasePackPdf} download="BOJ_Fineness_Form.docx" target="_blank" rel="noreferrer" className="text-decoration-none">
                    <Button 
                        variant="outline-dark" 
                        className="px-4 py-2 shadow-sm"
                        style={{ 
                            borderRadius: "8px",
                            fontWeight: "600",
                            letterSpacing: "0.5px",
                            borderWidth: "2px",
                            marginBottom: "10px"
                        }}
                    >
                        Download Undertaking
                    </Button>
                </a>
              </div>

              {uploaded ? (
                <Alert variant="success" className="fw-bold text-center">
                  Undertaking Uploaded Successfully
                </Alert>
              ) : (
                <Alert variant="warning" className="text-center">
                  Please download, sign and upload the undertaking form
                </Alert>
              )}

              {!uploaded && (
                <div className="mt-4">
                  <input
                    type="file"
                    className="form-control mb-3"
                    onChange={e => setFile(e.target.files[0])}
                  />

                  <div className="text-center">
                    <Button
                      variant="secondary"
                      onClick={uploadFile}
                      disabled={uploading}
                    >
                      {uploading ? (
                        <Spinner size="sm" animation="border" />
                      ) : (
                        "Upload Signed Undertaking"
                      )}
                    </Button>
                  </div>
                </div>
              )}

              {uploaded && fullFileUrl && (
                <div className="mt-4 text-center">

                  {/* IMAGE PREVIEW */}
                  {fullFileUrl.match(/\.(jpg|jpeg|png)$/i) && (
                    <img
                      src={`${process.env.REACT_APP_IMAGE_URL}/uploads/undertakings/${fullFileUrl}`}
                      className="img-fluid border rounded mb-3"
                      style={{ maxWidth: "350px" }}
                      alt="Undertaking Preview"
                    />
                  )}

                  {/* PDF PREVIEW */}
                  {fullFileUrl.endsWith(".pdf") && (
                    <iframe
                      src={`${process.env.REACT_APP_IMAGE_URL}/uploads/undertakings/${fullFileUrl}`}
                      width="100%"
                      height="450px"
                      title="Undertaking PDF"
                      className="border rounded"
                    />
                  )}

                  <div className="mt-3">
                    <a
                      href={`${process.env.REACT_APP_IMAGE_URL}/uploads/undertakings/${fullFileUrl}`}
                      download
                      target="_blank"
                      rel="noreferrer"
                      className="btn btn-link fw-bold"
                    >
                      Download Undertaking Form
                    </a>
                  </div>

                </div>
              )}

            </Card>
          </div>
        </div>
      </div>

    </ExhibitorLayout>
  );
};

export default UndertakingForm;
